module.exports = __webpack_public_path__ + "static/media/helmet-battle.d2c66c13.svg";